import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
import ErrorBox from './../../../../commons/ErrorBox';
import Checkbox from '@material-ui/core/Checkbox';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tick from './../../../../assets/img/tick.png'

export default class JobsReassignment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedProcess: null,
			selectedSpace: null,
			selectedCustomerGroup: null,
			selectedEquipmentType: null,
			reassignmentOpen: false,
			reassignmentConfirmation: false,
			reassignmentLoading: false,
			allChecked: false,
			showReassignSuccessScreen: false,
			selectedUsersForReassignment: [],
			users: [],
			error: null,
			showAllUsers: false,
			loadFetchUsers: false
		}
	}

	closeError = () => {
		this.setState({ error: null });
	}

	componentWillMount() {
		this.fetchUser(false);
	}

	componentDidMount() {
		let selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
		if (selectedFacility.facilityName !== "Sutlej/Gomati") {
			this.setState({
				selectedCustomerGroup: 'GENERAL'
			})
		}
	}

	//<!------------------------------- Selection of options -------------------------------!>
	processSelected = (phase) => {
		this.setState({ selectedProcess: phase });
	}

	spaceSelected = (space) => {
		this.setState({ selectedSpace: space });
	}

	customerGroupSelected = (custGrp) => {
		this.setState({ selectedCustomerGroup: custGrp });
	}

	equipmentTypeSelected = (eq) => {
		this.setState({ selectedEquipmentType: eq })
	}

	//<!------------------------------- Validations -------------------------------!>
	canReassign = () => {
		const { spaceTypes, customerGroup } = this.props;
		const { selectedProcess, selectedSpace, selectedCustomerGroup, selectedEquipmentType } = this.state;
		if (selectedProcess &&
			(spaceTypes && spaceTypes.length > 0 ? selectedSpace : true) &&
			(customerGroup && customerGroup.length > 0 ? selectedCustomerGroup : true) &&
			selectedEquipmentType) {
			return true;
		}
		return false;
	}

	//<!------------------------------- Handling Reassignment Dialog -------------------------------!>
	openReassignment = () => {
		this.setState({ reassignmentOpen: true });
	}

	reassignmentDialogClose = () => {
		this.setState({ reassignmentOpen: false });
	}

	//<!------------------------------- Handling Reassignment Confirmation Dialog -------------------------------!>
	askForReassignmentConfirmation = () => {
		this.setState({ reassignmentConfirmation: true, reassignmentOpen: false });
	}

	reassignmentConfirmationClose = () => {
		this.setState({ reassignmentConfirmation: false });
	}

	//<!------------------------------------- Handling user selection for reassignment -------------------------------------!>

	handleHeroCheckBox = (hero) => {
		var selected = this.state.selectedUsersForReassignment;
		if (hero.checkedVal) {
			for (var i in selected) {
				if (selected[i] === hero.naturalId) {
					selected.splice(i, 1);
					break;
				}
			}
			hero.checkedVal = false;
			this.setState({ selectedUsersForReassignment: selected, allChecked: false })
		} else {
			selected.push(hero.naturalId);
			hero.checkedVal = true;
			this.setState({ selectedUsersForReassignment: selected })
		}
	}

	handleAllCheck = () => {
		var allUsers = this.state.users;
		if (this.state.allChecked) {
			for (var i in allUsers) {
				allUsers[i].checkedVal = false;
			}
			this.setState({ allChecked: false, users: allUsers, selectedUsersForReassignment: [] })
		} else {
			var total = [];
			for (var j in allUsers) {
				allUsers[j].checkedVal = true;
				total.push(allUsers[j].naturalId);
			}
			this.setState({ allChecked: true, users: allUsers, selectedUsersForReassignment: total })
		}
	}

	//<!------------------------------------- Fetch Users For Role PICKING -------------------------------------!>
	fetchUser = (showAllUsers) => {

		this.setState({ loadFetchUsers: true });
		JobsOperationsApiHandler.getFcUsersForProcessType('PICKING', showAllUsers)
			.then(resp => {
				resp.sort(function (a, b) { return (a.displayName > b.displayName) ? 1 : ((b.displayName > a.displayName) ? -1 : 0); });
				this.setState({ users: resp });
			}).catch(error => {

			}).finally(() => {
				this.setState({ loadFetchUsers: false });
			})

	}


	//<!------------------------------- Reassignment Server Call -------------------------------!>
	proceedReassignment = () => {
		if (this.state.reassignmentLoading) {
			return;
		}
		this.setState({ reassignmentConfirmation: false, reassignmentOpen: true, reassignmentLoading: true });
		var request = {
			deliveryDate: this.props.selectedDate.epochTime,
			needsEquipmentForJob: 0,
			processPhase: this.state.selectedProcess.enum,
			userIds: this.state.selectedUsersForReassignment
		};
		if (this.state.selectedSpace) {
			request.floorSpaceId = this.state.selectedSpace.spaceId
		}
		if (this.state.selectedCustomerGroup) {
			request.customerType = this.state.selectedCustomerGroup
		}
		if (this.state.selectedEquipmentType === 'MHE') {
			request.needsEquipmentForJob = 1;
		}
		else if (this.state.selectedEquipmentType === 'NON_MHE') {
			request.needsEquipmentForJob = 0;
		}
		JobsOperationsApiHandler.reassignPickJobs(request)
			.then((resp) => {
				this.setState({ reassignmentOpen: false, showReassignSuccessScreen: true });
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ reassignmentLoading: false });
			});

	}

	closeSuccessScreen = () => {
		this.setState({ showReassignSuccessScreen: false });
	}


	//<!------------------------------- Reassignment Dialog Rendering -------------------------------!>

	getAllUsersToSelect = () => {
		var user;
		//this.state.users.sort(function(a,b) {return (a.displayName > b.displayName) ? 1 : ((b.displayName > a.displayName) ? -1 : 0);} );
		user = this.state.users.map((hero, index) => {
			if (hero.checkedVal === undefined) {
				hero.checkedVal = false;
			}
			return (
				<div className="fc-heroe-pick" key={index}>
					<div className="row">
						<div className="col-md-1 col-sm-1 col-xs-2">
							<Checkbox checked={hero.checkedVal} onChange={() => { this.handleHeroCheckBox(hero) }} value={hero.naturalId} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} />
						</div>
						<div className="col-md-11 col-sm-11 col-xs-10">
							<div>{hero.displayName} <span style={{ opacity: '0.7' }}>({hero.phoneNumber})</span> {hero.naturalId}</div>
						</div>
					</div>
				</div>
			);
		});
		return user;
	}

	changeUsers = (showAllUsers) => {
		this.setState({ showAllUsers: !showAllUsers });
		this.fetchUser(!showAllUsers);
	}

	reassignJobBoxRender = () => {
		const { showAllUsers, loadFetchUsers } = this.state;
		var totalSelcted = this.state.selectedUsersForReassignment.length;
		return (
			<div>
				<div style={{ position: 'sticky', top: '0', padding: '30px 30px 20px 30px', backgroundColor: '#fff', boxShadow: '0px 0px 10px 0px', zIndex: '5' }}>
					<div className="row">
						<div className="col-md-5">
							<div style={{ fontSize: '16px', fontWeight: 'bold' }}>Reassignment {this.state.selectedProcess ? this.state.selectedProcess.name : null}</div>
							<div>
								<span style={{ opacity: '0.6' }}>Delivery Date:</span> {this.props.selectedDate ? this.props.selectedDate.deliveryDate : null}
							</div>
						</div>
						<div className="col-md-3 centralized">
							<div style={{ opacity: '0.6' }}> Selected Users </div>
							<div>{totalSelcted}</div>
						</div>
						<div className="col-md-4">
							{(this.state.reassignmentLoading) ?
								<CircularProgress style={{ color: '#000' }} size={29} thickness={3} /> : null
							}
							<button className={"pull-right btn " + ((totalSelcted > 0) ? "btn-jt-green-out" : "btn-default no-rad")} disabled={totalSelcted === 0 ? true : false} onClick={this.askForReassignmentConfirmation}> Reassign Job </button>
						</div>
					</div>
					<div style={{ fontSize: '13px', color: 'gray', marginTop: '5px' }}>
						<Checkbox checked={showAllUsers} onChange={(e) => { this.changeUsers(showAllUsers) }} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} /> <span style={{ marginRight: '5px' }}>Show All Users</span>
						{loadFetchUsers ? <CircularProgress style={{ color: '#000' }} size={15} thickness={3} /> : null}
					</div>
				</div>
				<div style={{ padding: '0 30px 30px 30px' }}>
					<div>
						<div className="fc-heroe-pick">
							<div className="row">
								<div className="col-md-1 col-sm-1 col-xs-2">
									<Checkbox checked={this.state.allChecked} onChange={() => { this.handleAllCheck() }} value={"naturalId"} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} />
								</div>
								<div className="col-md-11 col-sm-11 col-xs-10">
									<div>Select All FC Users</div>
								</div>
							</div>
						</div>
						{this.getAllUsersToSelect()}
					</div>
				</div>
			</div>
		)
	}

	reassignmentDialog = () => {
		return (
			<div>
				<Dialog open={this.state.reassignmentOpen} onClose={this.reassignmentDialogClose} maxWidth="sm" fullWidth={true} onEntering={this.handleEntering} aria-labelledby="confirmation-dialog-title">
					{this.reassignJobBoxRender()}
				</Dialog>
			</div>
		);
	}

	reassignmentConfirmationDialog = () => {
		return (
			<div>
				<Dialog open={this.state.reassignmentConfirmation} onClose={this.reassignmentConfirmationClose} maxWidth="sm" onEntering={this.handleEntering} aria-labelledby="confirmation-dialog-title">
					<div style={{ padding: '30px', width: '400px', textAlign: 'center' }}>
						<div style={{ fontSize: '16px', lineHeight: '32px', fontWeight: '500' }}>
							<div>The list won't be edited later.</div>
							<div>Are you sure you want to proceed?</div>
						</div>
						<div className="row" style={{ marginTop: '30px' }}>
							<div className="col-md-6">
								<button className="btn btn-default" onClick={this.reassignmentConfirmationClose}>Cancel</button>
							</div>
							<div className="col-md-6">
								<button className="btn btn-jt-primary" onClick={this.proceedReassignment}>Proceed</button>
							</div>
						</div>
					</div>
				</Dialog>
			</div>
		);
	}


	//<!------------------------------- Main Render Method -------------------------------!>
	render() {
		const { selectedDate, processPhases, spaceTypes, customerGroup } = this.props;
		const { selectedProcess, selectedSpace, selectedCustomerGroup, selectedEquipmentType } = this.state;
		return (
			<div style={{ position: 'relative' }}>
				{(!selectedDate) ?
					<div className="blocked-selection-box"></div> : null
				}
				<div className="putaway-pallet-outer">
					<div className="row pick-name-holder">
						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="pick-item-label">Jobs Reassignment</div>
						</div>
					</div>
					<div className="pick-name-holder">
						<div className="top-twenty">
							<div className="row">
								<div className="col-md-10">
									<div className="row">
										<div className="col-md-3">
											<ExpDropSelector options={processPhases} selected={selectedProcess} classes={{ drop: 'pick-type-drop' }} selctionChange={this.processSelected} type={'Item Type'} value={'name'} />
										</div>
										{(spaceTypes && spaceTypes.length > 0) ?
											<div className="col-md-3" >
												<ExpDropSelector options={spaceTypes} selected={selectedSpace} classes={{ drop: 'pick-type-drop' }} selctionChange={this.spaceSelected} type={'Space Type'} value={'spaceDisplayName'} />
											</div> : null
										}
										{(customerGroup && customerGroup.length > 0) ?
											<div className="col-md-3" >
												<ExpDropSelector options={customerGroup} selected={selectedCustomerGroup} classes={{ drop: 'pick-type-drop' }} selctionChange={this.customerGroupSelected} type={'Customer Group'} />
											</div> : null
										}
										<div className="col-md-3">
											<ExpDropSelector options={this.props.equipmentType} selected={selectedEquipmentType} classes={{ drop: 'pick-type-drop' }} selctionChange={this.equipmentTypeSelected} type={'Equipment Type'} />
										</div>
									</div>
								</div>
								<div className="col-md-2">
									<button className={"btn pull-right " + ((this.canReassign()) ? "btn-jt-green-out" : "btn-default no-rad")} disabled={!this.canReassign()} onClick={this.openReassignment}>Reassign</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.reassignmentDialog()}
				{this.reassignmentConfirmationDialog()}
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
				{(this.state.showReassignSuccessScreen) ?
					<div className="randomErrorBox">
						<div className="errorContianer" style={{ width: '300px', textAlign: 'center', color: '#58a159', fontWeight: 'bold' }}>
							<div><img src={Tick} alt="success-img" style={{ width: '65px', height: '65px' }} /></div>
							<div className="top-twenty">Reassignment Done Successfully</div>
							<div className="top-twenty"><button className="btn btn-jt-green" onClick={this.closeSuccessScreen}>Okay</button></div>
						</div>
					</div> : null
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobsReassignment.js